var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play-button",class:{paused: _vm.paused},on:{"tap":function($event){return _vm.togglePlay()}}},[_c('img',{attrs:{"src":_vm.getPlayerButtonImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }